import api from '@pray/shared/utils/api';

import type { PutHubspotContactApiResponse } from './types';

type PropertiesData = {
  intentId: string;
};

type PutHubspotContactProps = {
  recaptchaToken: string;
  email: string;
  properties: PropertiesData;
};

export const putHubspotContact = async ({ recaptchaToken, email, properties }: PutHubspotContactProps) => {
  const body = {
    recaptcha_token: recaptchaToken,
    email,
    properties: {
      intent_id: properties.intentId,
    },
  };

  const response = await api.executePutRequest<PutHubspotContactApiResponse>(
    '/web/studio/plg/onboarding/hubspot/contact',
    body
  );

  return response.data;
};
